// extracted by mini-css-extract-plugin
export default {"labelWrapper":"date-label_labelWrapper__e-Ahf","labelYear":"date-label_labelYear__A0KuU","activeText":"date-label_activeText__vJsPY"};